import React, { FunctionComponent, useLayoutEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import Loadable from 'react-loadable';
import Loader from './Loader';

const { WINEM8_CHECKOUT_PATH, AI_INSTRUMENTATION_KEY } =
    (window as any).__WINEM8_ENV || {};

const AsyncCheckout = Loadable({
    loader: () => import('./checkout/Checkout'),
    loading: Loader,
    delay: 100,
    timeout: 10000,
});

const AsyncSubscriptions = Loadable({
    loader: () => import('./manage/Manage'),
    loading: Loader,
    delay: 100,
    timeout: 10000,
});

const AsyncCartPages = Loadable({
    loader: () => import('./cart/Cart'),
    loading: Loader,
    delay: 100,
    timeout: 10000,
});

const AsyncEditCartPages = Loadable({
    loader: () => import('./cart/EditCart'),
    loading: Loader,
    delay: 100,
    timeout: 10000,
});

const AsyncSelectionPage = Loadable({
    loader: () => import('./selection/Selection'),
    loading: Loader,
    delay: 100,
    timeout: 10000,
});

const AsyncPaymentAction = Loadable({
    loader: () => import('./payment-action/PaymentAction'),
    loading: Loader,
    delay: 100,
    timeout: 10000,
});

export const Application: FunctionComponent<{}> = () => {
    useLayoutEffect(() => {
        if (AI_INSTRUMENTATION_KEY) {
            const appInsights = new ApplicationInsights({
                config: {
                    instrumentationKey: AI_INSTRUMENTATION_KEY,
                    enableAutoRouteTracking: true,
                },
            });
            appInsights.loadAppInsights();
            appInsights.addTelemetryInitializer((envelope: any) => {
                envelope.tags['ai.cloud.role'] = 'winem8-checkout';
            });
            appInsights.trackPageView();
        }
    }, []);

    return (
        <Router basename={WINEM8_CHECKOUT_PATH}>
            <Switch>
                <Route exact path={`/checkout`} component={AsyncCheckout} />
                <Route exact path={`/manage`} component={AsyncSubscriptions} />
                <Route exact path={`/cart`} component={AsyncCartPages} />
                <Route
                    exact
                    path={`/selection`}
                    component={AsyncSelectionPage}
                />
                <Route
                    path={`/modify-subscription/:id`}
                    component={AsyncEditCartPages}
                />
                <Route
                    path={`/payment-action/:token`}
                    component={AsyncPaymentAction}
                />
            </Switch>
        </Router>
    );
};

export default Application;
